<template>
  <v-container>
    <v-row>
      <v-col cols="12" justify-center align-start>
        <v-skeleton-loader ref="skeleton" type="heading"></v-skeleton-loader>
        <p/>
        <v-row>
          <v-col cols="12" sm="5">
            <v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" sm="7">
            <v-skeleton-loader ref="skeleton" type="list-item-three-line"></v-skeleton-loader>
          </v-col>
        </v-row>
        <v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader>
        <v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AboutMeSkeleton"
};
</script>